import { useEffect } from 'react';

import { routes } from '@aline/routes';
import { matchPath, useLocation } from 'react-router-dom';

export const redirectPathKey = 'redirectPath';

/**
 * Store redirectPath in sessionStorage since that is scoped to each browser tab and is
 * cleared when the tab is closed.  Allows us to redirect to the correct page after login, etc.
 */
export function useSetRedirectPath() {
  const location = useLocation();

  useEffect(() => {
    const skipPaths = [
      routes.PreLogin,
      routes.Login,
      routes.MagicLinkSent,
      routes.MagicLinkResent,
      routes.Signup,
    ];
    const isCallback = location.pathname === routes.ExternalToolkitConnected;
    const shouldSkip =
      isCallback || skipPaths.some(path => matchPath({ end: false, path }, location.pathname));
    if (!shouldSkip) sessionStorage.setItem(redirectPathKey, location.pathname + location.search);
  }, [location]);
}

export function useRedirectPath() {
  return { redirectPath: sessionStorage.getItem(redirectPathKey) };
}
